/**
 * The inbox behind every "contact us" affordance in the app. Kept in one
 * place so a dead end never has to invent its own exit.
 */
const SUPPORT_EMAIL = 'dev@finlay.ai';

/** Public product docs, built from `help/` (see help/src/lib/site.ts). */
export const HELP_CENTER_URL = 'https://help.finlay.ai';

/** Prefills the subject so a request arrives with the context it came from. */
export const supportMailto = (subject: string) =>
  `mailto:${SUPPORT_EMAIL}?subject=${encodeURIComponent(subject)}`;
